<template>
    <RejectedLiquidations></RejectedLiquidations>
</template>
<script>
    import RejectedLiquidations from '@/components/RejectedLiquidations.vue'
    export default {
        name: 'approved-liquidations',
        components: {
            RejectedLiquidations
        }
    }
</script>